import { Component } from "react";
import React from "react";
import { Row, Col } from "react-bootstrap";
import { Question as ScenarioQuestion, Answer } from '../../services/Learning';
import Utils from "../../services/Utils";
import AnswersComponent from "./AnswersComponent";

export interface IQuestionProp {
    question : ScenarioQuestion,
    selectedAswersChanged: (selectedAnswers: (Answer | null) []) => void,
    optionalAnswersChanged: (optionalAnswers: string[]) => void
}

class Question extends Component<IQuestionProp> {
    
    constructor(props: IQuestionProp)
    {
        super(props);
    }
    
    public render() {
        return (
            <div>
                <Row>
                    <Col md={8}>
                        <h2>{this.props.question ? this.props.question. title : ''}</h2>
                        <div dangerouslySetInnerHTML={{__html: this.props.question.text}} ></div>
                    </Col>
                    {this.props.question.image ?
                        <Col md={4}>
                            <img src={Utils.getFileUrl(this.props.question.image) || ''} width="100%" className='question-image'/>
                        </Col>
                    : null}
                </Row>
                <Row className="answers-prev-next">
                    <Col md={12} className='answers'>
                        {/* <h3 style={{textAlign: "left"}}>Варианты ответов</h3> */}
                        <AnswersComponent answers={this.props.question.answers}
                            multiAnswerAllowed={this.props.question.allowMultiple}
                            optionalAnswerAllowed={this.props.question.allowOptional}
                            selectedAswersChanged={this.props.selectedAswersChanged}
                            optionalAnswersChanged={this.props.optionalAnswersChanged}
                            questionId={this.props.question.id}/>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Question;